/** Set by app.ts after Checkpoint client auth succeeds. */
let currentUserId: string | number | null = null;

export function setCurrentUserId(id: string | number): void {
    currentUserId = id;
}

export function getCurrentUserId(): string | number | null {
    return currentUserId;
}
